import React, { useState, useEffect } from "react";

interface ToggleSwitchProps {
  defaultChecked?: boolean;
  disabled?: boolean;
  onToggle?: (value: boolean) => void;
  confirmToggle?: (nextValue: boolean) => Promise<boolean>;
}

export default function ToggleSwitch({
  defaultChecked = false,
  disabled = false,
  onToggle,
  confirmToggle
}: ToggleSwitchProps) {
  const [checked, setChecked] = useState(defaultChecked);

  // Sync with parent if defaultChecked changes
  useEffect(() => {
    setChecked(defaultChecked);
  }, [defaultChecked]);

  const handleChange = async () => {
    if (disabled) return;

    const nextValue = !checked;

    if (confirmToggle) {
      const confirmed = await confirmToggle(nextValue);
      if (!confirmed) return;
    }

    setChecked(nextValue);
    onToggle?.(nextValue);
  };

  return (
    <label
      className={`relative inline-flex items-center ${
        disabled ? "cursor-not-allowed opacity-80" : "cursor-pointer"
      }`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className="sr-only peer"
      />

      {/* Background track */}
      <div
        className={`w-11 h-6 rounded-full transition-colors ${
          disabled
            ? checked
              ? "bg-success-200"
              : "bg-neutral-100"
            : checked
              ? "bg-success-500"
              : "bg-neutral-200"
        }`}
      ></div>

      <div
        className={`absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full transition-all shadow
          ${checked ? "translate-x-5" : ""}
        `}
      ></div>
    </label>
  );
}
